import uniqueId from 'lodash/uniqueId';
import React from 'react';
import type { PrettifiedBuffer, PrettifiedBufferItem } from './types';
import prettifiedAtoms from './components';


export default function createPrettifiedBuffer(): PrettifiedBuffer {
  const prettifiedLinesPerActionPublicId: Record<string, PrettifiedBufferItem[]> = {};

  return {
    append: entry => {
      const arr = Array.isArray(entry) ? entry : [entry];
      arr.forEach(entryToAppend => {
        const {
          actionPublicId,
          line,
          id = uniqueId(),
        } = entryToAppend;

        if (!Object.hasOwn(prettifiedLinesPerActionPublicId, actionPublicId)) {
          prettifiedLinesPerActionPublicId[actionPublicId] = [];
        }

        prettifiedLinesPerActionPublicId[actionPublicId].push({
          Component: line,
          id,
        });
      });
    },
    package: () => (
      /* a little negative margin is added to account for the margin-top the of the first heading1 */
      <div style={{ height: '100%', width: '100%', marginTop: 'calc(-1 * var(--cl-space-2))' }}>
        {(
          Object
            .entries(prettifiedLinesPerActionPublicId)
            .flatMap(([actionPublicId, linesForAction], idx, array) => {
              // render every line for the action
              const Components = linesForAction.map(({ Component, id }) => <Component key={id} />);
              const EmptyLine = prettifiedAtoms.emptyLine();

              const isLastAction = idx + 1 === array.length;

              /**
               * separate every action section by an extra empty line. skips adding it
               * on the last action to avoid creating dead space at the bottom.
               */
              return isLastAction
                ? Components
                : [
                  ...Components,
                  <EmptyLine key={actionPublicId} />,
                ];
            })
        )}
      </div>
    ),
  };
}
